import React from 'react'

import { t } from 'i18next'

import Status from '~/components/Status'

import { ExternalCampaignMetricsStatus } from '../../types'

type StatusBadgeProps = {
  status: ExternalCampaignMetricsStatus | string
}

type StatusColor = 'success' | 'warning' | 'danger' | 'info' | 'default'

const statusConfig: Record<
  ExternalCampaignMetricsStatus,
  { label: string; color: StatusColor }
> = {
  [ExternalCampaignMetricsStatus.Pending]: {
    label: t('rm:externalCampaignMetrics.status.pending'),
    color: 'warning'
  },
  [ExternalCampaignMetricsStatus.Processing]: {
    label: t('rm:externalCampaignMetrics.status.processing'),
    color: 'info'
  },
  [ExternalCampaignMetricsStatus.Completed]: {
    label: t('rm:externalCampaignMetrics.status.completed'),
    color: 'success'
  },
  [ExternalCampaignMetricsStatus.Error]: {
    label: t('rm:externalCampaignMetrics.status.error'),
    color: 'danger'
  }
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status as ExternalCampaignMetricsStatus]

  if (!config) {
    return <span>{status}</span>
  }

  return (
    <Status
      status={{
        label: config.label,
        type: config.color
      }}
    />
  )
}

export default StatusBadge
